import { createRouter, createWebHistory } from "vue-router";
import FoilCutter1 from "@/views/FoilCutter1.vue";
import FoilCutter2 from "@/views/FoilCutter2.vue";
import FoilCutter3_BackSheet from "@/views/FoilCutter3_BackSheet.vue";
// import HomePage from "@/views/HomePage.vue";
import GlassLoader1 from "@/views/GlassLoader1.vue";
import GlassLoader2 from "@/views/GlassLoader2.vue";
import Ribbon from "@/views/RibbonView.vue";
import Cell from "@/views/CellView.vue";
import JBox from "@/views/JBoxView.vue";
import Potting from "@/views/PottingView.vue";
import Silicon from "@/views/SiliconView.vue";
import Flux from "@/views/FluxView.vue";
import StringPeel from "@/views/StringPeelView.vue";
import FoilPeel from "@/views/FoilPeelView.vue";
import { env } from '../config/env'
import { isAuthenticated } from "../auth";

const routes = [
  {
    path: "/",
    component: FoilCutter1,
  },
  {
    path: "/FoilCutter1",
    component: FoilCutter1,
  },
  {
    path: "/FoilCutter2",
    component: FoilCutter2,
  },
  {
    path: "/FoilCutter3",
    component: FoilCutter3_BackSheet,
  },
  {
    path: "/GlassLoader1",
    component: GlassLoader1,
  },
  {
    path: "/GlassLoader2",
    component: GlassLoader2,
  },
  {
    path: "/ribbon",
    component: Ribbon,
  },
  {
    path: "/cell",
    component: Cell,
  },
  {
    path: "/j-box",
    component: JBox,
  },
  {
    path: "/potting",
    component: Potting,
  },
  {
    path: "/silicon",
    component: Silicon,
  },
  {
    path: "/flux",
    component: Flux,
  },
  {
    path: "/string-peel",
    component: StringPeel,
  },
  {
    path: "/foil-peel",
    component: FoilPeel,
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === "/logged-in") {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);
      return next("/");
    }
  }

  if (!(await isAuthenticated())) {
    const baseUrl = env.API_BASE_URL;
    window.location.href = `${baseUrl}/auth/azure?app=mdc`;
  } else {
    next();
  }
});

export default router;
